import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    category: {
      validations: [
        { type: 'required', message: 'Please select the type of event' }
      ]
    },
    clientname: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please provide a city' }
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please provide a state' }
      ]
    },
    postal: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' }
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please provide the name of the location or venue' }
      ]
    },
    accountextra2: {
      validations: [
        { type: 'required', message: 'Please provide a reference' }
      ]
    },
    accountextra9: {
      validations: []
    },
    Website: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What Type of Event are you planning?: *',
            options: [
              { label: 'Corporate', value: 'Corporate'},
              { label: 'Non-Profit/Gala', value: 'Non-Profit'},
              { label: 'Social', value: 'Social'}
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name / Organization:',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name: *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name: *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number: *',
            mapping: 'telNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'E-mail Address: *',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City: *',
            mapping: 'city'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State/Prov: *',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal:',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'XLarge',
            label: 'Event Date (MM/DD/YYYY): *',
            mapping: 'eventDate'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Est. Guest Count: *',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'What would your preferred Event Timing be?',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Start Time:',
            options: [
              { label: '6:00AM'  , value: '06:00:00'},
              { label: '6:30AM'  , value: '06:30:00'},
              { label: '7:00AM'  , value: '07:00:00'},
              { label: '7:30AM'  , value: '07:30:00'},
              { label: '8:00AM'  , value: '08:00:00'},
              { label: '8:30AM'  , value: '08:30:00'},
              { label: '9:00AM'  , value: '09:00:00'},
              { label: '9:30AM'  , value: '09:30:00'},
              { label: '10:00AM' , value: '10:00:00'},
              { label: '10:30AM' , value: '10:30:00'},
              { label: '11:00AM' , value: '11:00:00'},
              { label: '11:30AM' , value: '11:30:00'},
              { label: '12:00PM' , value: '12:00:00'},
              { label: '12:30PM' , value: '12:30:00'},
              { label: '1:00PM'  , value: '13:00:00'},
              { label: '1:30PM'  , value: '13:30:00'},
              { label: '2:00PM'  , value: '14:00:00'},
              { label: '2:30PM'  , value: '14:30:00'},
              { label: '3:00PM'  , value: '15:00:00'},
              { label: '3:30PM'  , value: '15:30:00'},
              { label: '4:00PM'  , value: '16:00:00'},
              { label: '4:30PM'  , value: '16:30:00'},
              { label: '5:00PM'  , value: '17:00:00'},
              { label: '5:30PM'  , value: '17:30:00'},
              { label: '6:00PM'  , value: '18:00:00'},
              { label: '6:30PM'  , value: '18:30:00'},
              { label: '7:00PM'  , value: '19:00:00'},
              { label: '7:30PM'  , value: '19:30:00'},
              { label: '8:00PM'  , value: '20:00:00'},
              { label: '8:30PM'  , value: '20:30:00'},
              { label: '9:00PM'  , value: '21:00:00'},
              { label: '9:30PM'  , value: '21:30:00'},
              { label: '10:00PM' , value: '22:00:00'},
              { label: '10:30PM' , value: '22:30:00'},
              { label: '11:00PM' , value: '23:00:00'},
              { label: '11:30PM' , value: '23:30:00'},
              { label: '12:00AM' , value: '24:00:00'},
              { label: '12:30AM' , value: '24:30:00'},
              { label: '1:00AM'  , value: '01:00:00'},
              { label: '1:30AM'  , value: '01:30:00'},
              { label: '2:00AM'  , value: '02:00:00'}
            ],
            mapping: 'starttime'
          },
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'End Time:',
            options: [
              { label: '6:00AM'  , value: '06:00:00'},
              { label: '6:30AM'  , value: '06:30:00'},
              { label: '7:00AM'  , value: '07:00:00'},
              { label: '7:30AM'  , value: '07:30:00'},
              { label: '8:00AM'  , value: '08:00:00'},
              { label: '8:30AM'  , value: '08:30:00'},
              { label: '9:00AM'  , value: '09:00:00'},
              { label: '9:30AM'  , value: '09:30:00'},
              { label: '10:00AM' , value: '10:00:00'},
              { label: '10:30AM' , value: '10:30:00'},
              { label: '11:00AM' , value: '11:00:00'},
              { label: '11:30AM' , value: '11:30:00'},
              { label: '12:00PM' , value: '12:00:00'},
              { label: '12:30PM' , value: '12:30:00'},
              { label: '1:00PM'  , value: '13:00:00'},
              { label: '1:30PM'  , value: '13:30:00'},
              { label: '2:00PM'  , value: '14:00:00'},
              { label: '2:30PM'  , value: '14:30:00'},
              { label: '3:00PM'  , value: '15:00:00'},
              { label: '3:30PM'  , value: '15:30:00'},
              { label: '4:00PM'  , value: '16:00:00'},
              { label: '4:30PM'  , value: '16:30:00'},
              { label: '5:00PM'  , value: '17:00:00'},
              { label: '5:30PM'  , value: '17:30:00'},
              { label: '6:00PM'  , value: '18:00:00'},
              { label: '6:30PM'  , value: '18:30:00'},
              { label: '7:00PM'  , value: '19:00:00'},
              { label: '7:30PM'  , value: '19:30:00'},
              { label: '8:00PM'  , value: '20:00:00'},
              { label: '8:30PM'  , value: '20:30:00'},
              { label: '9:00PM'  , value: '21:00:00'},
              { label: '9:30PM'  , value: '21:30:00'},
              { label: '10:00PM' , value: '22:00:00'},
              { label: '10:30PM' , value: '22:30:00'},
              { label: '11:00PM' , value: '23:00:00'},
              { label: '11:30PM' , value: '23:30:00'},
              { label: '12:00AM' , value: '24:00:00'},
              { label: '12:30AM' , value: '24:30:00'},
              { label: '1:00AM'  , value: '01:00:00'},
              { label: '1:30AM'  , value: '01:30:00'},
              { label: '2:00AM'  , value: '02:00:00'}
            ],
            mapping: 'endtime'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Where would you like to host your event?: *',
            options: [
              { label: 'Boston Public Library', value: 'Boston Public Library'},
              { label: 'Institute of Contemporary Art', value: 'Institute of Contemporary Art'},
              { label: 'Harvard Art Museums', value: 'Harvard Art Museums'},
              { label: 'Boston Athenaeum', value: 'Boston Athenaeum'},
              { label: 'SoWa Powerstation', value: 'SoWa Powerstation'},
              { label: 'Boston Lyric Opera'  , value: 'Boston Lyric Opera'},
              { label: 'Midtown Race Club', value: 'Midtown Race Club'},
              { label: 'Home', value: 'Home'},
              { label: 'Office', value: 'Office'},
              { label: 'Tented', value: 'Tented'},
              { label: 'Other Venue', value: 'Other Venue'},
            ],
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Referred By: *',
            options: [
              { label: 'Search Engine'  , value: 'Search Engine'},
              { label: 'Google Ad'  , value: 'Google Ad'},
              { label: 'AI Search (ChatGPT, etc.)'  , value: 'AI Search (ChatGPT, etc.)'},
              { label: 'Social Media'  , value: 'Social Media'},
              { label: 'Planner / DMC'  , value: 'Planner / DMC'},
              { label: 'PartySlate'  , value: 'PartySlate'},
              { label: 'Meet Boston'  , value: 'Meet Boston'},
              { label: 'Venue Referral'  , value: 'Venue Referral'},
              { label: 'Friend or Family Referral'  , value: 'Friend or Family Referral'},
              { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'accountextra2'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'If Other, please provide reference:',
            mapping: 'accountextra9'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Please tell us more about your event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'TCA Contact Event Form',
    formId: '2006',
    clientKey: 'B46D4299-E772-4E44-9F26-2D7CBE3D9B91',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.thecateredaffair.com/success/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
